import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

// Define a drawerOpening for the slice state
interface drawerOpeningState {
  show: boolean;
}

// Define the initial state using that drawerOpening
const initialState: drawerOpeningState = {
  show: true,
};

export const drawerOpeningSlice = createSlice({
  name: "drawerOpening",
  // `createSlice` will infer the state drawerOpening from the `initialState` argument
  initialState,
  reducers: {
    adddrawerOpening: (state) => {
      state.show = true;
    },
    removedrawerOpening: (state) => {
      state.show = false;
    },
  },
});

export const { adddrawerOpening, removedrawerOpening } =
  drawerOpeningSlice.actions;

export const isdrawerOpening = (state: RootState) => state.drawerOpening.show;

export default drawerOpeningSlice.reducer;
